import { render, staticRenderFns } from "./LiveSchedule.vue?vue&type=template&id=1106bc04&"
import script from "./LiveSchedule.vue?vue&type=script&lang=js&"
export * from "./LiveSchedule.vue?vue&type=script&lang=js&"
import style0 from "./LiveSchedule.vue?vue&type=style&index=0&id=1106bc04&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports